import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./OfflineOrderTableHeader.module.scss"

const OfflineOrderTableHeader = () => {
  const [t, i18n] = useTranslation()

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <thead>
      <tr className={classes["header"]}>
        <th
          className={clsx(
            classes["header-item2"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("کد")}
        </th>
        <th
          className={clsx(
            classes["header-item3"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("وضعیت")}
        </th>
        <th
          className={clsx(
            classes["header-item4"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("تاریخ")}
        </th>
        <th
          className={clsx(
            classes["header-item5"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("نحوه_تحویل")}
        </th>
        <th
          className={clsx(
            classes["header-item5"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("طریق_سفارش")}
        </th>
        {
          serviceTypeName === "restaurant" &&
          <th
            className={clsx(
              classes["header-item5"],
              isLtr && classes["header-item-ltr"]
            )}
          >
            {t("شماره_میز")}
          </th>
        }
        <th
          className={clsx(
            classes["header-item6"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("جزئیات")}
        </th>
      </tr>
    </thead>
  )
}

export default OfflineOrderTableHeader